import { Editor, EditorContent } from "@tiptap/vue-2"
import StarterKit from "@tiptap/starter-kit"
import Placeholder from "@tiptap/extension-placeholder"
import Underline from "@tiptap/extension-underline"

export default {
	components: {
		EditorContent
	},

	data() {
		return {
			editor: null,
			message: "",
			lastHeight: 0,
			timesHeight: 0
		}
	},

	mounted() {
		this.editor = new Editor({
			extensions: [
				StarterKit,
				Placeholder.configure({
					placeholder: "Just Write"
				}),
				Underline
			],
			content: ""
		})
		this.editor.on("update", () => {
			this.message = this.editor.getHTML()
		})
	},
	methods: {
		initObserver() {
			const ro = new ResizeObserver((entries) => {
				for (let entry of entries) {
					const cr = entry.contentRect
					if (cr.height <= 6 * 40) {
						document.body.style.setProperty(
							"--input-height",
							cr.height + 30 + "px"
						)
					}
				}
			})

			ro.observe(this.$refs.chatInput)
		},
		clearContent() {
			this.editor.commands.clearContent(true)
		}
	},
	beforeDestroy() {
		this.editor.destroy()
	}
}
